import React, { useEffect, useRef } from "react";
import "./styles/App.css";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Main from "./components/Main.jsx";
import Auth from "./auth/Auth.jsx";
import { toast, ToastContainer } from "react-toastify";
import Item from "./components/Item.jsx";
import Wishlist from "./components/Wishlist.jsx";
import CartPage from "./components/CartPage.jsx";
import SearchPage from "./components/SearchPage.jsx";
import AdminPage from "./components/AdminPage.jsx";
import { useSelector } from "react-redux";
import GoogleCallback from "./auth/GoogleCallBack.jsx";
import UserProfile from "./components/Profile.jsx";
import ForgotPassword from "./auth/ForgotPassword.jsx";
import AboutUs from "./components/AboutUs.jsx";
import ContactUs from "./components/ContactUs.jsx";

const ProtectedRoute = ({ children }) => {
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const location = useLocation();
  const hasShownToast = useRef(false);
  useEffect(() => {
    if (!isLoggedIn && !hasShownToast.current) {
      toast.warn("Please login to access this page!", {
        position: "top-center",
        autoClose: 2000,
      });
      hasShownToast.current = true;
    }
  }, [isLoggedIn]);

  if(!isLoggedIn){
    console.log(location.pathname);
    return <Navigate to="/register" replace={true}/>;
    
  }
  return children;
}

const CustomRoute = ({children}) => {
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  if(isLoggedIn){
    return <Navigate to="/" replace={true}/>;
  }
  return children;
}



function App() {

  return (
    <Router>
      <Routes>
        <Route path="/auth/google/callback" element={<GoogleCallback/>}/>
        <Route path="/register" element={<CustomRoute><Auth /></CustomRoute>} />
        <Route path="/forgot" element={<ForgotPassword/>} />
        <Route path="/" element={<Main />} />
        <Route path="/item/:id" element={<Item />} />
        <Route path="/wishlist" element={<ProtectedRoute><Wishlist /></ProtectedRoute>} />
        <Route path="/cart" element={<ProtectedRoute><CartPage/></ProtectedRoute>} />
        <Route path="/shop" element={<SearchPage />} />
        <Route path="/shop?category=kidswear" element={<SearchPage />} />
        <Route path="/shop?category=menswear" element={<SearchPage />} />
        <Route path="/admin" element={<ProtectedRoute><AdminPage /></ProtectedRoute>} />
        <Route path="/profile" element={<ProtectedRoute><UserProfile /></ProtectedRoute>} />
        <Route path="/about" element={<AboutUs/>}/>
        <Route path="/contact" element={<ContactUs/>}/>

      </Routes>
      <ToastContainer />
    </Router>

  );
}


export default App;